import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { laborHoursConstant } from 'src/redux/actions/constant';
import laborHoursService from 'src/services/apiServices/laborHoursService/laborHoursService';

function* getLaborHours(action: any): SagaReturnType<any> {
  try {
    yield put({ type: laborHoursConstant.GET_LABOR_HOURS_LOADER });
    const response = yield call(laborHoursService.getLaborHoursList, action.payload);
    if (response?.status === 200) {
      yield put({ type: laborHoursConstant.GET_LABOR_HOURS_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: laborHoursConstant.GET_LABOR_HOURS_FAILURE, payload: error });
  }
}

function* getLaborHoursSaga() {
  yield takeEvery(laborHoursConstant.GET_LABOR_HOURS_REQUEST, getLaborHours);
}

export default getLaborHoursSaga;
